import { ApiDOHSessionResponse, ApiResponseType } from '../../types/types';
import { callAPIEndpoint } from './api';

export const apiInitDOHSession = async (recordKeys: string[], bearerToken?: string): Promise<string> => {
  let recordKeysStr = recordKeys.join(',');
  let sessionResponse: ApiDOHSessionResponse = await callAPIEndpoint(`/init/doh/session?record_ids=${recordKeysStr}`, 'GET', undefined, ApiResponseType.JSON, bearerToken);
  return sessionResponse.SessionID;
};
